import { ReactNode } from "react";
import { useGetStrategyDashboardHeatsQuery } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";
import { HeatsDataContext } from "./HeatsDataContext";
import { useHeatsDataContextValue } from "./useHeatsDataContextValue";

interface ComplianceHeatsDataProviderProps {
  children: ReactNode;
  start: string;
  end: string;
  page: number;
  resultsPerPage: number;
}

export const ComplianceHeatsDataProvider = ({
  children,
  start,
  end,
  page,
  resultsPerPage,
}: ComplianceHeatsDataProviderProps) => {
  const tenantName = useTenant();

  const {
    data,
    isLoading: isHeatsLoading,
    isFetching: isHeatsFetching,
    isError: isHeatsError,
  } = useGetStrategyDashboardHeatsQuery({
    tenantName,
    start,
    end,
    resultsPerPage,
    page,
  });

  const value = useHeatsDataContextValue({
    data,
    isFetching: isHeatsFetching,
    isLoading: isHeatsLoading,
    isError: isHeatsError,
  });

  return <HeatsDataContext value={value}>{children}</HeatsDataContext>;
};
